import { CrudService } from "../../core/services/crudService";
import { Settings } from "../../core/services/configService";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import store from "../../core/store";

type T = (key: string) => string;

// The tenant's courses, with the customer's progress merged in when there is a session.
export class CourseList {
  static async load(): Promise<any[]> {
    const crud = new CrudService();
    const customer = CustomerHelper.getStoredCustomer();
    const [all, mine] = await Promise.all([
      crud.httpGet(`${Settings.HostName}/api/public-courses/list`),
      customer ? crud.httpGet(`${Settings.HostName}/api/public-courses/my-courses`) : Promise.resolve(null),
    ]);
    const byId: any = {};
    ((mine && mine.data) || []).forEach((c: any) => (byId[c.id] = c));
    return ((all && all.data) || []).map((c: any) => (byId[c.id] ? { ...c, ...byId[c.id] } : c));
  }

  // The course poster; without one, the thumbnail of its YouTube promo video.
  static cover(c: any): string {
    if (c.poster) {
      return c.poster.startsWith("http") ? c.poster : (store.state.settings && store.state.settings.Uploads) + "/" + c.poster;
    }
    const id = this.youTubeId(c.promoVideoEmbed || "");
    return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
  }

  static youTubeId(url: string): string {
    const match = url.match(/(?:youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?v=)|youtu\.be\/)([\w-]{11})/);
    return match ? match[1] : "";
  }

  static duration(seconds: number): string {
    return Math.round((seconds || 0) / 60) + " min";
  }

  static facts(t: T, c: any): string {
    const bits: string[] = [];
    if (c.sectionCount > 1) bits.push(c.sectionCount + " " + t("sections"));
    bits.push(c.lessonCount + " " + t("lessons"));
    if (c.totalDuration) bits.push(this.duration(c.totalDuration));
    return bits.join(" · ");
  }

  static progress(t: T, c: any): string {
    return c.percentComplete > 0 ? c.completedLessons + " " + t("of") + " " + c.lessonCount + " " + t("completed") : "";
  }
}
